<template>
    <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title"><i class="fas fa-handshake"></i> Partnership Type</h4>
                <h6 class="card-subtitle">Manage participants with admin in this platform</h6>
            </div>
            <div class="card-body card-blue collapse show" v-if="partnership.length > 0">
                <div class="table-responsive">
                    <table class="table no-wrap v-middle">
                        <thead>
                        <tr class="border-0">
                            <th class="border-0">#</th>
                            <th class="border-0">Name</th>
                            <th class="border-0">Description</th>
                            <th class="border-0">Type</th>
                            <th class="border-0">Created on</th>
                            <th class="border-0">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-bind:key="index" v-for="(p, index) in partnership">
                            <td>{{index+1}}</td>
                            <td>{{p.name}}</td>
                            <td>{{p.description | truncate(30, '...')}}</td>
                            <td>{{p.type | capitalize}}</td>
                            <td>{{p.created_at | date}}</td>
                            <td>
                                <router-link :to="{name: 'viewparnershiptype', params : {partnershipid: p.id}}"><h6>View</h6></router-link>
                                <a><b></b></a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
            <div class="card-body card-blue" v-else>
                <h4 class="card-title text-muted text-center">No records found</h4>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Create New Partnership Type</h4>
            </div>

            <form @submit.prevent="handleSubmit" class="form-horizontal">
                <div class="card-body card-blue">
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label" for="partnership_name">Name</label>
                        <div class="col-sm-6">
                            <input :class="{'is-invalid': submitted && errors.has('partnership_name')}" class="form-control"
                                   data-vv-as="Name"
                                   id="partnership_name"
                                   name="partnership_name"
                                   placeholder="Partnership Name"
                                   type="text"
                                   v-model="partnership_name"
                                   v-validate="'required'">
                            <div class="invalid-feedback" v-if="submitted && errors.has('partnership_name')">{{ errors.first('partnership_name') }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label" for="partnership_desc">Description</label>
                        <div class="col-sm-6">
                            <textarea :class="{'is-invalid': submitted && errors.has('partnership_desc')}" class="form-control"
                                      data-vv-as="Description"
                                      id="partnership_desc"
                                      name="partnership_desc"
                                      placeholder="Partnership Description"
                                      type="text"
                                      v-model="partnership_desc"
                                      v-validate="'required'"></textarea>
                            <div class="invalid-feedback" v-if="submitted && errors.has('partnership_desc')">{{ errors.first('partnership_desc') }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 text-right control-label col-form-label" for="partnership_type">Type</label>
                        <div class="col-sm-6">
                            <input :class="{'is-invalid': submitted && errors.has('partnership_type')}" class="form-control"
                                   data-vv-as="Fee"
                                   id="partnership_type"
                                   name="partnership_type"
                                   placeholder="Partnership Type"
                                   type="text"
                                   v-model="partnership_type"
                                   v-validate="'required'">
                            <div class="invalid-feedback" v-if="submitted && errors.has('partnership_type')">{{ errors.first('partnership_type') }}</div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="form-group m-b-0 text-right">
                        <div class="button-group">
                            <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                            <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';

    export default {
        name: "PartnerType",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Paginate},
        data() {
            return {
                submitted: false,
                total: 0,
                partnership: [],
                pageCount: 1,
                partnership_name: '',
                partnership_desc: '',
                partnership_type: ''
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await this.getPartnershipType(1);
            },
            async getPartnershipType(page) {
                try {
                    let reply        = await this.$http
                    .get("/express/" + this.currentOrg.express_id + "/partnership", {
                        params: {
                            page: page,
                            perPage: 10
                        }
                    });
                    this.total       = reply.data.total;
                    this.partnership = reply.data.partnership;
                } catch(e) {
                    console.log(err);
                }
            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            },
            pageHandler(pageNum) {
                this.getPlans(pageNum);
            },
            async savePartnership() {
                try {
                    await this.$http
                    .put("/express/" + this.currentOrg.express_id + "/partnership", {
                        name: this.partnership_name,
                        description: this.partnership_desc,
                        type: this.partnership_type
                    })
                } catch(e) {
                    console.error(e);
                }
            },
            async handleSubmit() {
                this.submitted = true;

                try {
                    let valid = await this.$validator.validate();
                    if(valid) {
                        await this.savePartnership();
                        this.reset();
                        this.getPartnershipType(1);
                    }
                } catch(e) {
                    console.error(e);
                }
            },
            reset() {
                this.submitted = false;
                this.partnership_name = '',
                this.partnership_desc = '',
                this.partnership_type = ''
            },
        }
    }
</script>

<style scoped>

</style>
